import taxonomyService from '../main/taxonomyService'
import React from 'react';
import {Row, Col} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import {FormattedMessage, injectIntl} from 'react-intl';
import i18n from "../main/i18n";

export default injectIntl(props => {

  const {serviceAreaId, evidenceTypeId} = props.match.params;
  const serviceArea = taxonomyService.getServiceArea(serviceAreaId);
  const evidenceType = taxonomyService.getEvidenceType(serviceArea, evidenceTypeId);

  const params = new URLSearchParams(props.location.search);
  const referenceNumber = params.get('ref');

  const notifications = params.get('notifications') || '';
  const notificationsArray = notifications.split(',');
  const emailSent = notificationsArray.indexOf('EMAIL') > -1;
  const smsSent = notificationsArray.indexOf('PHONE') > -1;

  const msg = i18n.getMsg(props.intl);
  const submissionType = msg(`customer.${process.env.REACT_APP_CUSTOMER}.submissionType`);
  const submissionTitle = msg(`customer.${process.env.REACT_APP_CUSTOMER}.submissionTitle`);
  const submissionSuccessMsg = msg(`customer.${process.env.REACT_APP_CUSTOMER}.submissionSuccessMsg`);
  const notificationMessage = emailSent && smsSent ? msg('receipt.emailAndPhone') :
    emailSent ? msg('receipt.email') :
      smsSent ? msg('receipt.phone') : null;

  return (
    <Row>
      <Col md={8} lg={6}>
        <h3>
          <FormattedMessage id="evidence.submitted" defaultMessage="{submitTitle}" values={{submitTitle: submissionTitle}}/>
        </h3>
        <div className="alert alert-info" role="alert">
          <FormattedMessage id="evidence.refNum"
                            defaultMessage="Your reference number is: {referenceNumber}"
                            values={{referenceNumber: <strong>{referenceNumber}</strong>}}/>
        </div>
        <p>
          <FormattedMessage id="evidence.success" defaultMessage="{submitSuccessMsg}" values={{submitSuccessMsg: submissionSuccessMsg}}/>
        </p>

        <dl className="dl-horizontal">
          <dt><FormattedMessage id="serviceArea" defaultMessage="Service Area"/></dt>
          <dd>{serviceArea.label}</dd>

          <dt><FormattedMessage id="evidenceType" defaultMessage="{submitType}" values={{submitType: submissionType}}/></dt>
          <dd>{evidenceType.label}</dd>
        </dl>
        {
          notificationMessage &&
          <div className="alert alert-info" role="alert">
            {notificationMessage}
          </div>
        }
        <Link to="/" className="simple-text logo-normal">
          <button className="btn btn-fill btn-primary">
            <FormattedMessage id="ok" defaultMessage="OK"/>
          </button>
        </Link>
      </Col>
    </Row>
  );
});
